import React from "react";
import {Link} from "react-router-dom";

class ESimCompatible extends React.Component {
  render() {
    return (
      <section className="section QASection">
        {/* <div className="bg-overlay" / >*/}
        <div className="container">
          <div className="row">
			<div className="col-md-12"><div className="line"></div></div>
            <div className="col-lg-12">
              <div className="desktop-header">
                <h5 className="mb-2 SansSerif bold600">Android</h5>
				<div className="row">
                  <div className="col-4">
✓ Samsung Galaxy S20<br/>
✓ Samsung Galaxy S20+<br/>
✓ Samsung Galaxy S20+ 5g<br/>
✓ Samsung Galaxy S20 Ultra<br/>
✓ Samsung Galaxy S21<br/>
✓ Samsung Galaxy S21+ 5G<br/>
✓ Samsung Galaxy S21+ Ultra 5G<br/>
✓ Samsung Galaxy S22<br/>
✓ Samsung Galaxy S22+<br/>
✓ Samsung Galaxy S22 Ultra<br/>
✓ Samsung Galaxy Note 20<br/>
✓ Samsung Galaxy Note 20 Ultra 5G<br/>
✓ Samsung Galaxy Fold<br/>
✓ Samsung Galaxy Z Fold2 5G<br/>
✓ Samsung Galaxy Z Fold3 5G<br/>
✓ Samsung Galaxy Z Fold4<br/>
✓ Samsung Galaxy Z Flip<br/>
✓ Samsung Galaxy Z Flip3 5G<br/>
✓ Samsung Galaxy Z Flip4<br/>
✓ Samsung Galaxy S23<br/>
✓ Samsung Galaxy S23+<br/>
✓ Samsung Galaxy S23 Ultra
                  </div>
                  <div className="col-4">
✓ Google Pixel 2<br/>
✓ Google Pixel 2 XL<br/>
✓ Google Pixel 3<br/>
✓ Google Pixel 3 XL<br/>
✓ Google Pixel 3a<br/>
✓ Google Pixel 3a XL<br/>
✓ Google Pixel 4<br/>
✓ Google Pixel 4a<br/>
✓ Google Pixel 4 XL<br/>
✓ Google Pixel 5<br/>
✓ Google Pixel 5a<br/>
✓ Google Pixel 6<br/>
✓ Google pixel 6a<br/>
✓ Google Pixel 6 Pro<br/>
✓ Google Pixel 7<br/>
✓ Google Pixel 7 Pro<br/>
✓ Huawei P40<br/>
✓ Huawei P40 Pro<br/>
✓ Huawei Mate 40 Pro<br/>
✓ Oppo Find X3 Pro<br/>
✓ Oppo Reno 5A<br/>
✓ Oppo Find X5<br/>
✓ Oppo Find X5 Pro
                  </div>
				  <div className="col-4">
✓ Motorola Razr 2019<br/>
✓ Motorola Razr 5G<br/>
✓ Gemini PDA<br/>
✓ Rakuten Mini<br/>
✓ Rakuten Big-S<br/>
✓ Rakuten Big<br/>
✓ Rakuten Hand<br/>
✓ Rakuten Hand 5G<br/>
✓ Sony Xperia 10 III Lite<br/>
✓ Sony Xperia 10 IV<br/>
✓ Xperia 1 IV<br/>
✓ Sony Xperia 5 IV<br/>
✓ Surface Pro X<br/>
✓ Honor Magic 4 Pro<br/>
✓ Fairphone 4<br/>
✓ Sharp Aquos Sense6s<br/>
✓ Sharp Aquos Wish<br/>
✓ Xiaomi 12T Pro<br/>
✓ DOOGEE V30

                  </div>
				</div>            
              </div>
			</div>
	      </div>

          <div className="row" style={{paddingTop: "50px"}}>
            <div className="col-lg-12">
              <div className="desktop-header">
                <h5 className="mb-2 SansSerif bold600">iPhone</h5>
				<div className="row">
                  <div className="col-4">
✓ iPhone XR<br/>
✓ iPhone XS<br/>
✓ iPhone XS Max<br/>
✓ iPhone 11<br/>
✓ iPhone 11 Pro<br/>
✓ iPhone SE 2nd generation (2020)<br/>
✓ iPhone 12<br/>
✓ iPhone 12 Mini<br/>
✓ iPhone 12 Pro<br/>
✓ iPhone 12 Pro Max<br/>
✓ iPhone 13<br/>
✓ iPhone 13 Mini<br/>
✓ iPhone 13 Pro<br/>
✓ iPhone 13 Pro Max<br/>
✓ iPhone SE 3rd generation (2022)<br/>
✓ iPhone 14<br/>
✓ iPhone 14 Plus<br/>
✓ iPhone 14 Pro<br/>
✓ iPhone 14 Pro Max
                  </div>
                  <div className="col-8">
*Google Pixel 2 / 2XL have eSIM capability which is only exclusive to Google Fi network.<br/><br/>
*Google Pixel 3 / 3 XL devices originating from Australia, Taiwan, and Japan, and those bought with service from US or Canadian carriers other than Sprint and Google Fi DO NOT have eSIM capability.<br/><br/>
*Google Pixel 3a / 3a XL devices bought in South East Asia and Japan, and with Verizon service DO NOT have eSIM capability.<br/><br/>
*Huawei P40 Pro+ devices DO NOT have eSIM capability.<br/><br/>
*Oppo Find X5 Lite devices DO NOT have eSIM capability.<br/><br/>

*iPhone devices from Mainland China DO NOT have eSIM capability.<br/><br/>
*iPhone devices from Hong Kong and Macao (except for the iPhone 13 Mini, iPhone 12 Mini, iPhone SE 2nd generation (2020), and iPhone XS) DO NOT have eSIM capability.
                  </div>
				</div>            
              </div>
			</div>
	      </div>

        </div>
      </section>
    );
  }
}

export default ESimCompatible;



// WEBPACK FOOTER //
// ./src/reusable/ESimCompatible.js